import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faArrowUp, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { DashCard } from "./DashCard";

type DashIconVariant = "accent" | "good" | "warning" | "critical" | "accent2";

interface DashStatTileProps {
  label: string;
  value: string;
  icon: IconDefinition;
  variant?: DashIconVariant;
  change?: { value: number; isPositive: boolean };
  footnote?: string;
  isLoading?: boolean;
  /** "hero" pra número grande (padrão), "name" pra texto/nome mais longo (fonte menor) */
  size?: "hero" | "name";
}

const DashStatTile = ({
  label,
  value,
  icon,
  variant = "accent",
  change,
  footnote,
  isLoading = false,
  size = "hero",
}: DashStatTileProps) => {
  if (isLoading) {
    return (
      <DashCard hoverable={false}>
        <div className="dash-stat">
          <div className="dash-skeleton" style={{ height: 11, width: "50%", marginBottom: 12 }} />
          <div className="dash-skeleton" style={{ height: 30, width: "70%", marginBottom: 10 }} />
          <div className="dash-skeleton" style={{ height: 14, width: "40%" }} />
        </div>
      </DashCard>
    );
  }

  return (
    <DashCard>
      <div className="dash-stat">
        <div className="d-flex justify-content-between align-items-start gap-2">
          <p className="dash-stat-label" style={{ minWidth: 0 }}>{label}</p>
          <div
            className={`dash-card-icon dash-card-icon--${variant}`}
            style={{ width: 30, height: 30, fontSize: "0.75rem", flexShrink: 0 }}
          >
            <FontAwesomeIcon icon={icon} />
          </div>
        </div>
        <div
          className="dash-stat-value"
          style={size === "name" ? { fontSize: "1.2rem", lineHeight: 1.25 } : undefined}
        >
          {value}
        </div>
        {(change || footnote) && (
          <div className="dash-stat-footer">
            {change && (
              <span className={`dash-pill ${change.isPositive ? "dash-pill--good" : "dash-pill--critical"}`}>
                <FontAwesomeIcon icon={change.isPositive ? faArrowUp : faArrowDown} style={{ fontSize: "0.6rem" }} />
                {change.value.toFixed(1)}%
              </span>
            )}
            {footnote && <span style={{ color: "var(--dash-muted)" }}>{footnote}</span>}
          </div>
        )}
      </div>
    </DashCard>
  );
};

export default DashStatTile;
